export const ROLES_LIST = [
  'ROLE_USER',
  'ROLE_COURSE_CREATOR',
  'ROLE_SEO_EDITOR',
  'ROLE_ADDER_AND_EDIT_OWN',
  'ROLE_REVIEW_CODE_USER',
  'ROLE_BRANCH_USER',
  'ROLE_BRANCH_ADMIN',
  'ROLE_COMPANY_ADMIN',
  'ROLE_ADMIN',
  'ROLE_SUPER_ADMIN',
];

export const ROLES = {
  ROLE_USER: 'ROLE_USER',
  ROLE_COURSE_CREATOR: 'ROLE_COURSE_CREATOR',
  ROLE_SEO_EDITOR: 'ROLE_SEO_EDITOR',
  ROLE_ADDER_AND_EDIT_OWN: 'ROLE_ADDER_AND_EDIT_OWN',
  ROLE_REVIEW_CODE_USER: 'ROLE_REVIEW_CODE_USER',
  ROLE_BRANCH_USER: 'ROLE_BRANCH_USER',
  ROLE_BRANCH_ADMIN: 'ROLE_BRANCH_ADMIN',
  ROLE_COMPANY_ADMIN: 'ROLE_COMPANY_ADMIN',
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_SUPER_ADMIN: 'ROLE_SUPER_ADMIN',
};
